import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/content/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$orgSlug/$projectId/content/text',
      params: { orgSlug: params.orgSlug, projectId: params.projectId }
    })
  }
})
